export default __webpack_public_path__ + "media/images/svg/dot-5d20102762a32ba0b2df08bd9d7c510e.svg";